<template>
    <b-modal ref="modalEditDangerCasRef" id="id-modal-edit-danger-cas" size="xl" :title="getTitleModal" hide-footer scrollable no-close-on-backdrop no-close-on-esc>
      <template #modal-header-close>
        <b-button @click="closeModal" variant="light">
          <i class="fa fa-close fa-lg"></i>
        </b-button>
      </template>
      <EditDanger :closeModal="closeModal"></EditDanger>
    </b-modal>
  </template>
  <script>
  // Importaciones generales
  import { mapState, mapMutations, mapActions } from 'vuex';
  // Componentes
  import EditDanger from './EditDanger.vue';
  import Components from '../Crear.vue';
  export default {
    name: "ModalEditDanger",
    components: {
      EditDanger,
      Components
    },
    computed: {
      ...mapState('nuevocas', {
        currentDangerActive: 'currentDangerActive'
      }),
      getTitleModal() {
        return this.currentDangerActive ? this.currentDangerActive.lista : ''
      }
    },
    methods: {
      ...mapActions('nuevocas', [
        'listarTipoCas',
      ]),
      ...mapMutations('nuevocas', [
        'setCurrentDangerActive'
      ]),
      showModal() {
        this.$bvModal.show('id-modal-edit-danger-cas')
      },
      async closeModal() {
        this.setCurrentDangerActive(null)
        this.$bvModal.hide('id-modal-edit-danger-cas')
        await this.listarTipoCas()
      }
    }
  }
  </script>
  <style scoped>
  </style>